import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  value: Number.NaN,
};

const bemessungslastGruppeGesamtSlice = createSlice({
  name: "bemessungslastGruppeGesamt",
  initialState,
  reducers: {
    setBemessungslastGruppeGesamtState(state, action) {
      state.value = action.payload.value;
    },
    setBemessungslastGruppeGesamt(state, action) {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const { setBemessungslastGruppeGesamtState, setBemessungslastGruppeGesamt } =
  bemessungslastGruppeGesamtSlice.actions;

export default bemessungslastGruppeGesamtSlice.reducer;

export const selectBemessungslastGruppeGesamt = (state) => state.bemessungslastGruppeGesamt.value;
